import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'semantic-ui-react'

// TODO: remove first zeros
class InputPercent extends React.Component {
  onChange = e => {
    const {maxValue, minValue} = this.props
    let value = parseFloat(e.target.value || '0')
    if (value > maxValue) { 
      value=maxValue
    } else if (value < minValue) { 
      value=minValue 
    }
    this.props.onChange({
      target: {
        name: e.target.name,
        value: parseFloat((value / 100).toFixed(9))
      }
    })
  }

  onKeyPress = e => {
    // TODO: Check on Firefox
    if(e.key === '.' && e.target.value.includes('.')){
      e.preventDefault()
    }
  }
  
  selectValue = e => e.target.select()

  render() {
    const { name, value, disabled, label, step } = this.props
    const _value = parseFloat((value * 100).toFixed(8)) || 0
    let { style } = this.props
    if (!!style && !style.hasOwnProperty('minWidth')) { style = {...style, minWidth: '110px'}}
    return (
      <Input fluid
        style={style}
        label={label}
        onFocus={this.selectValue}
        disabled={disabled}
        onKeyPress={this.onKeyPress}
        icon='percent'
        value={ _value }
        step={!step?'any':step}
        name={ name }
        type='number'
        onChange={ this.onChange }/>
    );
  }
}

InputPercent.defaultProps = {
  disabled: false,
  minValue: -100,
  maxValue: 100
}

// TODO: add value with CORRECT type
InputPercent.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  onChange: PropTypes.func.isRequired,
}

export default InputPercent;
